import { Form, Input } from 'antd';
import { FormItemProps } from 'antd/lib/form';
import { InputProps } from 'antd/lib/input';
import React from 'react';

const RoomNameFormItem = ({
  name,
  formItemProps,
  inputProps,
}: {
  name: string;
  formItemProps?: FormItemProps;
  inputProps?: InputProps;
}) => {
  return (
    <Form.Item
      label='Choose a name'
      name={name}
      rules={[{ required: true, message: 'Please add a name' }]}
      {...formItemProps}>
      <Input
        autoFocus
        autoComplete='off'
        style={{ height: 40, textAlign: 'center' }}
        {...inputProps}
      />
    </Form.Item>
  );
};

export default RoomNameFormItem;
